import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isLogged, loading } = useAuth();
  const location = useLocation();

  // 🔄 أثناء التحقق من التوكن
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  // 🚫 غير مسجل دخول → رجّعه مع حفظ الصفحة
  if (!isLogged) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  // ✅ مسجل دخول
  return children;
}